 
import Header from '../header';
import { useState } from "react";

export default function Contactus() {

    const [message , setMessage] = useState(false)

    const handleSubmit = (e)=>{
        e.preventDefault();
        setMessage(true)
    }
  return (
    <div className=' boardingTitle'>
    <div className='colorpage'>
<Header />
</div>

<div className="container-fluid">


<div className="row">
               <div className="col-lg-6">
               <img className="contactimage" src="images/edit.jpg" alt="iphone-mockup" />
                
               <h5 className='mt-3'>Follow us for your daily update</h5>
               <a href="/posh"> <i className="social-icon fab fa-facebook-square"></i></a>
   <a href="https://twitter.com/Posh_Mo"><i className="social-icon fab fa-twitter-square"></i></a>
   <a href="https://www.instagram.com/posh_mo/"><i className="social-icon fab fa-instagram"></i></a>
  <a href = "mailto: ispeakfordogs@yahoo.com? subject = Feedback&body = Message"> <i className="social-icon fas fa-envelope-square"></i></a>
               
                  
               </div>
               <div className="col-lg-6">
                
                <h2>Contact.</h2>
                <p>Contact us today to learn more about our premium services! Please complete the form and we will respond to you shortly.</p>
                <form  className="formdesign" onSubmit={handleSubmit} >
                    <input type="text" placeholder="Email" />
                    <textarea  placeholder="Message"></textarea>
                    <button type="submit"> Submit</button>
                    {message && <span>thanks, I will reply ASAP </span>}

                </form>
             
                  
               </div>
           </div>

            
            </div>    
                   
                  
               


               
           {/* <!-- Footer -->  */}

   <footer id="footer"   >
       <div className='footerPositioning' >
   <a href="/posh"> <i className="social-icon fab fa-facebook-square"></i></a>
   <a href="https://twitter.com/Posh_Mo"><i className="social-icon fab fa-twitter-square"></i></a>
   <a href="https://www.instagram.com/posh_mo/"><i className="social-icon fab fa-instagram"></i></a>
  <a href="/posh"> <i className="social-icon fas fa-envelope-square"></i></a>
       <p>© Copyright PmPaws</p>
       </div>
   </footer>
</div>
  )
}
